import { NeoModel, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

@NeoModel
export default class BankDetail extends ValueObject {

    @Rules.Required()
    public bankId: number | null = null;

    @Rules.Required()
    public bankAccountTypeId: number | null = null;

    @Rules.Required()
    @Rules.StringLength(100)
    public bankAccountName: string = "";

    @Rules.Required()
    @Rules.StringLength(15)
    public bankBranchCode: string = "";

    @Rules.Required()
    @Rules.StringLength(50)
    public bankAccountNumber: string = "";

    @Rules.StringLength(100)
    public bankBranchName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        // Allow digits and spaces.
        const isDigit = (testString: string): boolean => !/[^0-9 ]/.test(testString);
        
        rules.failWhen(c => !isDigit(c.bankAccountNumber), "Bank account number can only contain numbers")
        rules.failWhen(c => !isDigit(c.bankBranchCode), "Bank branch code can only contain numbers")
    }

    public toString(): string {
        return "Bank Detail";
    }
}